import {AbstractView} from "./AbstractView";
import HiddenLayer = require("./HiddenLayer");
import {ViewStatus} from "../event/EventStaus";
import ThumbnailsCarousel = require("./ThumbnailsCarousel");

export class AccessoriesView<T> extends AbstractView<T> {

    constructor(template: T) {
        super(template);
    }

    init(): void {
        this.createTriggerBtn();
        this.createCarousel();
    }

    private createTriggerBtn(): void {

        let btnTotal: number = $(".accessoriesView").find(".triggerBtn").length;
        for (let i: number = 0; i < btnTotal; i++) {
            let btn: JQuery = $(".accessoriesView").find(".triggerBtn:eq(" + i + ")");
            btn.on("click tap", {id: i}, (event: JQuery.Event) => {
                event.preventDefault();
                // @ts-ignore
                this.changeCarousel(event.data["id"])
            });
        }
    }

    private carouselData: any[];

    private createCarousel(): void {
        this.carouselData = [
            {
                selector: ".beg-container",
                carousel: ".begCarousel",
                controls: ".begControls",
                thumbnails: ".begThumbnails",
                target: null
            },
            {
                selector: ".headset-container",
                carousel: ".headCarousel",
                controls: ".headControls",
                thumbnails: ".headThumbnails",
                target: null
            },
            {
                selector: ".mouse-container",
                carousel: ".mouseCarousel",
                controls: ".mouseControls",
                thumbnails: ".mouseThumbnails",
                target: null
            }
        ];

        for (let i: number = 0; i < this.carouselData.length; i++) {
            let targetCarousel: ThumbnailsCarousel = new ThumbnailsCarousel(
                $(".accessoriesView").find(this.carouselData[i]["selector"]),
                $(".accessoriesView").find(this.carouselData[i]["carousel"]),
                $(".accessoriesView").find(this.carouselData[i]["controls"]),
                $(".accessoriesView").find(this.carouselData[i]["thumbnails"])
            );
            this.carouselData[i]["target"] = targetCarousel;
            targetCarousel.transitionOut();
        }
    }

    private changeCarousel(id: number): void {
        for (let i: number = 0; i < this.carouselData.length; i++) {
            let targetCon: ThumbnailsCarousel = this.carouselData[i]["target"];
            if (i == id) {
                targetCon.transitionIn();
            } else {
                targetCon.transitionOut();
            }
        }
    }

}